var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgYoutubeIcon = function SvgYoutubeIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 42,
    viewBox: "0 0 54 42",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 21L23 12.9591V29.0408L35 21Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 21C1 28.4769 1.76853 32.8637 2.35277 35.1184C2.50894 35.7342 2.80885 36.3037 3.22764 36.7798C3.64644 37.2558 4.17206 37.6247 4.76097 37.8559C13.1302 41.0885 27 40.9998 27 40.9998C27 40.9998 40.8696 41.0885 49.2389 37.8559C49.8279 37.6248 50.3535 37.2558 50.7723 36.7798C51.1911 36.3037 51.491 35.7342 51.6472 35.1185C52.2314 32.8638 53 28.4769 53 21C53 13.5231 52.2315 9.13626 51.6472 6.88159C51.4911 6.26582 51.1912 5.69631 50.7724 5.22025C50.3536 4.74419 49.8279 4.37528 49.239 4.14409C40.8698 0.911476 27 1.00024 27 1.00024C27 1.00024 13.1304 0.911479 4.76105 4.14406C4.17214 4.37525 3.64651 4.74415 3.22771 5.22021C2.80891 5.69627 2.509 6.26578 2.35283 6.88155C1.76857 9.13621 1 13.5231 1 21Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgYoutubeIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/youtube-icon.008ad452.svg";
export { ForwardRef as ReactComponent };